import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@life-os/ui/liquid-calm.css';
import './styles/app.css';
import { App } from './App.js';

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Register the offline-shell service worker in production builds only (avoids
// caching interfering with dev/HMR). Runtime offline behaviour needs a real
// browser to verify end-to-end.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* registration is best-effort; the app works without it */
    });
  });
}
